import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang";

export default function Footer() {
    const { t } = useLang();
    return (
        <footer className="border-t border-slate-200 mt-24">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
                <div className="md:col-span-2">
                    <div className="flex items-center mb-3">
                        <img src="/logo.png" alt="Vivoz" className="h-9 w-auto" />
                    </div>
                    <p className="text-sm text-slate-500 max-w-md">
                        AI-powered training for orators. Speak. Listen. Improve.
                    </p>
                </div>
                <div>
                    <div className="mono-label mb-3">Product</div>
                    <ul className="space-y-2 text-sm text-slate-600">
                        <li>{t("nav.features")}</li>
                        <li>{t("nav.pricing")}</li>
                    </ul>
                </div>
                <div>
                    <div className="mono-label mb-3">Legal</div>
                    <ul className="space-y-2 text-sm text-slate-600">
                        <li><Link to="/terms" className="hover:text-brand" data-testid="footer-terms-link">Terms</Link></li>
                        <li><Link to="/privacy" className="hover:text-brand" data-testid="footer-privacy-link">Privacy</Link></li>
                    </ul>
                    <div className="mono-label mt-6 mb-1">© 2026</div>
                    <p className="text-sm text-slate-500">Built with rigour.</p>
                </div>
            </div>
        </footer>
    );
}

